import { render, staticRenderFns } from "./BoundaryOrgBoundaryEditModal.vue?vue&type=template&id=b4cb3c6e&scoped=true"
import script from "./BoundaryOrgBoundaryEditModal.vue?vue&type=script&lang=js"
export * from "./BoundaryOrgBoundaryEditModal.vue?vue&type=script&lang=js"
import style0 from "./BoundaryOrgBoundaryEditModal.vue?vue&type=style&index=0&id=b4cb3c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb3c6e",
  null
  
)

export default component.exports